import { render, staticRenderFns } from "./EditorDeTexto.vue?vue&type=template&id=0c4a3b93&"
import script from "./EditorDeTexto.vue?vue&type=script&lang=js&"
export * from "./EditorDeTexto.vue?vue&type=script&lang=js&"
import style0 from "./EditorDeTexto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports